/**
 * Re-export shim. The ProgramConfiguration View was hoisted into
 * `@solomon-apps/shared/src/widgets/yaas/programs` so external consumers
 * (the "+New Program" wiki doc) can render the bare Configuration section
 * fixture-driven, with no wallet / RPC / orgApiFetch.
 *
 * `yaas-client` keeps importing it from this path unchanged. The app's full
 * `Program` shape is a structural superset of the widget's minimal
 * `ProgramConfig` prop, so ProgramDetail can keep passing a real `Program`
 * straight through.
 *
 * @see packages/shared/src/widgets/yaas/programs/ProgramConfiguration.tsx
 */
export {
    ProgramConfiguration,
    type ProgramConfigurationProps
} from "@solomon-apps/shared/src/widgets/yaas/programs/ProgramConfiguration";
